var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.53 9.47a.75.75 0 010 1.06l-4.646 4.647a1.25 1.25 0 01-1.768 0L6.47 10.53a.75.75 0 111.06-1.06L12 13.94l4.47-4.47a.75.75 0 011.06 0z",
    fill: "currentColor"
  })));
}
SvgChevronDown.displayName = 'ChevronDown';
export default SvgChevronDown;